var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAutobrightness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.27 22.11-1.58-1.35c-.16-.14-.56-.28-.77-.28H6.17a2.68 2.68 0 0 1-2.68-2.68v-1.71c0-.21-.14-.61-.27-.76l-1.36-1.6c-.82-.97-.82-2.49 0-3.47l1.36-1.6c.13-.15.27-.55.27-.76V6.2c0-1.48 1.2-2.68 2.68-2.68H7.9c.21 0 .6-.15.77-.29l1.58-1.35c.98-.83 2.51-.83 3.49 0l1.58 1.35c.16.14.57.28.78.28h1.7c1.48 0 2.68 1.2 2.68 2.68v1.7c0 .21.15.6.29.77l1.35 1.58c.84.99.83 2.52 0 3.49l-1.35 1.58c-.14.17-.28.56-.28.77v1.7c0 1.48-1.2 2.68-2.68 2.68h-1.7c-.21 0-.6.15-.78.29l-1.58 1.35c-.49.43-1.12.64-1.74.64-.63 0-1.25-.21-1.74-.63zM4.99 6.2v1.7c0 .57-.26 1.29-.63 1.73L3 11.23c-.34.41-.34 1.13 0 1.53l1.35 1.59c.36.41.63 1.16.63 1.73v1.71c0 .65.53 1.18 1.18 1.18H7.9c.56 0 1.3.27 1.74.64l1.59 1.36c.41.35 1.12.35 1.54 0l1.58-1.35c.45-.38 1.18-.64 1.74-.64h1.7c.65 0 1.18-.53 1.18-1.18v-1.7c0-.56.27-1.29.64-1.74l1.36-1.59c.35-.41.35-1.13 0-1.54l-1.35-1.58c-.38-.45-.64-1.18-.64-1.74V6.2c0-.65-.53-1.18-1.18-1.18h-1.7c-.57 0-1.31-.27-1.75-.64l-1.59-1.36c-.41-.35-1.12-.35-1.54 0L9.65 4.38c-.45.37-1.18.64-1.75.64H6.17c-.65 0-1.18.53-1.18 1.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 9.91-2.81 6.33-1.38-.61 3.5-7.87h1.38l3.5 7.87-1.38.61L12 9.91z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.06c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.5c.41 0 .75.34.75.75s-.34.75-.75.75h-3.5z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAutobrightness);
export default __webpack_public_path__ + "static/media/vuesax-outline-autobrightness.672903a65af224934ecdbfad076b604d.svg";
export { ForwardRef as ReactComponent };